import {
    FETCH_INVOICES,
    FETCH_INVOICES_FAILURE,
    FETCH_INVOICES_SUCCESS,
    INVOICES_LIST_FILTER_UPDATE,
    INVOICES_LIST_FILTER_CATEGORY,
    INVOICES_LIST_PAGE,
    INVOICES_LIST_SORT,
    SORT_DESC,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'id',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_INVOICES:
            return {
                ...state,
                loading: true,
            };
        case FETCH_INVOICES_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case FETCH_INVOICES_SUCCESS:
            const data = utils.mapToObject(action.response.results, (entity) => {
                return entity.id;
            });

            return {
                ...state,
                data,
                ids: Object.keys(data),
                loading: false,
                offset: action.response.offset,
                size: action.response.size || state.size,
                total: action.response.total,
            };
        case INVOICES_LIST_PAGE:
            return {
                ...state,
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            };
        case INVOICES_LIST_SORT:
            return {
                ...state,
                field: action.payload.field,
                order: action.payload.order,
            };
        case INVOICES_LIST_FILTER_UPDATE: {
            const normalisedStatePayload = reducerHelper.normaliseState(initialState, action.payload);

            return {
                ...state,
                ...normalisedStatePayload,
            };
        }
        case INVOICES_LIST_FILTER_CATEGORY:
            return {
                ...state,
                filterCategory: action.payload,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/invoices/invoicesReducer.js